<script>
	import Lead from "./components/Lead.svelte";
	import content from "./content-en.yml";
</script>

<div class="scrolly">
	{#each content as block}
		<!-- lead section -->
		{#if block.type == "lead"}
			<Lead kicker={block.kicker} heading={block.heading} teaser={block.teaser} paywall={true} />
		{/if}
	{/each}
</div>

<style>
	.scrolly {
		font-family: "Abril Text", Helvetica, Arial, sans-serif;
		font-size: 20px;
		line-height: 32px;
	}

	@media (max-width: 480px) {
		.scrolly {
			font-size: 17px;
			line-height: 26px;
		}
	}

	/* @media (min-width: 980px) {
		:global(.lead-content > .content) {
			top: 90vh !important;
		}
	} */
</style>
